/// <reference types="@types/gtag.js" />

export const getGtag = (): Gtag.Gtag => window.gtag

export const getPageLocation = (): string => window.location?.href

export const getPagePath = (): string => window.location?.pathname

export const getPageTitle = (): string => window.document?.title
